jQuery(function() {

	// Top Accordion
	$('.product-main-accordion-item').on('click', 'h4', function() {
		$(this).parent().siblings().removeClass('product-main-accordion-item-active');
		$(this).parent().toggleClass('product-main-accordion-item-active');
	});

	// Top Slider
	var productPageMainSlider = new Swiper(".product-page-everyone-slider", {
		slidesPerView: 1,
		loop: true,
		center: false,
		spaceBetween: 24,
		centeredSlides: false,
		freeMode: false,
		autoHeight: true,
		navigation: {
			nextEl: ".product-page-everyone-slider-arrow-next",
			prevEl: ".product-page-everyone-slider-arrow-prev",
		},
		breakpoints: {
			992: {
				centeredSlides: false,
				slidesPerView: 3,
				spaceBetween: 24,
			},
		}
	});


	// Pin points slider in mobile
	var productPagePinMobile = new Swiper(".product-page-pin-mobile", {
		slidesPerView: 1,
		loop: true,
		center: false,
		spaceBetween: 16,
		centeredSlides: false,
		freeMode: false,
		pagination: {
			el: ".product-page-pin-mobile-navigation",
			clickable: true,
		},
		breakpoints: {
			992: {
				enabled: false
			},
		}
	});

	// Pin points hover menu
	$('.pin-point').on('click', function() {
		$(this).toggleClass('pin-point-active').siblings().removeClass('pin-point-active');
	});
});

//Main thumbs
let productPageMainThumbsSlider = new Swiper(".product-page-main-slider-thumbs-onload", {
	spaceBetween: 10,
	slidesPerView: 5,
	freeMode: false,
	watchSlidesProgress: true,
	direction: "vertical",
	navigation: {
		nextEl: ".icon-arrow-slider-thumbs-right",
		prevEl: ".icon-arrow-slider-thumbs-left",
	},
});
productPageMainThumbsSlider.on('slideChangeTransitionEnd', function (e) {
	let slider_index = $('.swiper-slide-active').data('swiper-slide-index');
	let slider_element = $(`[data-swiper-slide-index="${slider_index}"]`);
	let slider_type = slider_element.data('slider-type');

	if(slider_type == 'video') {
		slider_element.find("video").trigger('play');
	}else{
		$('video').trigger('pause');
	}
});

//Main gallery
productPageMainSlider = new Swiper(".product-page-main-slider-onload", {
	slidesPerView: 1,
	loop: false,
	center: false,
	spaceBetween: 16,
	centeredSlides: false,
	freeMode: false,
	observer: true,
	resizeReInit: true,
	navigation: {
		nextEl: ".icon-arrow-slider-right",
		prevEl: ".icon-arrow-slider-left",
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	thumbs: {
		swiper: productPageMainThumbsSlider,
	},
});
productPageMainSlider.on('slideChangeTransitionEnd', function (e) {
	let slider_index = $('.swiper-slide-active').data('swiper-slide-index');
	let slider_element = $(`[data-swiper-slide-index="${slider_index}"]`);
	let slider_type = slider_element.data('slider-type');

	if(slider_type == 'video') {
		slider_element.find("video").trigger('play');
	}else{
		$('video').trigger('pause');
	}
});


function activateVariantImagesGallery(color_name) {
	if(typeof productPageMainThumbsSliderNew != 'undefined') {
		productPageMainThumbsSliderNew.destroy();
	}

	if(productPageMainThumbsSlider) {
		productPageMainThumbsSlider.destroy();
	}

	$('.product-page-main-slider-color-thumbs').hide();
	$(`.product-page-main-slider-color-thumbs.${color_name}`).show();

	productPageMainThumbsSliderNew = new Swiper(`.product-page-main-slider-color-thumbs.${color_name}`, {
		spaceBetween: 10,
		slidesPerView: 5,
		freeMode: true,
		watchSlidesProgress: true,
		direction: "vertical",
		navigation: {
			nextEl: ".icon-arrow-slider-thumbs-right",
			prevEl: ".icon-arrow-slider-thumbs-left",
		},
	});

	productPageMainThumbsSliderNew.on('slideChangeTransitionEnd', function (e) {
		let slider_index = $('.product-page-main-slider-color-thumbs .swiper-slide-active').data('swiper-slide-index');
		let slider_element = $(`.product-page-main-slider-color-thumbs [data-swiper-slide-index="${slider_index}"]`);
		let slider_type = slider_element.data('slider-type');

		if(slider_type == 'video') {
			slider_element.find("video").trigger('play');
		}else{
			$('video').trigger('pause');
		}
	});


	//Main gallery
	if(typeof productPageMainSliderNew != 'undefined') {
		productPageMainSliderNew.destroy();
	}

	if(productPageMainSlider) {
		productPageMainSlider.destroy();
	}

	$('.product-page-main-slider-color').hide();
	$(`.product-page-main-slider-color.${color_name}`).show();

	productPageMainSliderNew = new Swiper(`.product-page-main-slider-color.${color_name}`, {
		slidesPerView: 1,
		loop: false,
		center: false,
		spaceBetween: 16,
		centeredSlides: false,
		freeMode: false,
		observer: true,
		resizeReInit: true,
		navigation: {
			nextEl: ".icon-arrow-slider-right",
			prevEl: ".icon-arrow-slider-left",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		thumbs: {
			swiper: productPageMainThumbsSliderNew,
		},
	});

	productPageMainSliderNew.on('slideChangeTransitionEnd', function (e) {
		let slider_index = $('.product-page-main-slider-color .swiper-slide-active').data('swiper-slide-index');
		let slider_element = $(`.product-page-main-slider-color [data-swiper-slide-index="${slider_index}"]`);
		let slider_type = slider_element.data('slider-type');

		if(slider_type == 'video') {
			slider_element.find("video").trigger('play');
		}else{
			$('video').trigger('pause');
		}
	});
}

